import React, { useEffect } from 'react';

function EditInput(props) {
  const {
    setValue,
    register,
    title,
    value,
    editing,
    errors,
    field,
    onChange,
    disabled,
    required = true,
    pattern,
    patternErrorMessage = '*請輸入正確的資料',
    readOnlyRightAlign = false,
  } = props;

  useEffect(() => {
    if (setValue) {
      setValue(field, value);
    }
  }, [field, setValue, value]);

  return (
    <>
      <div className={`flex items-center`}>
        <p className="text-gray w-1/2">{title}</p>
        {editing ? (
          <>
            <input
              disabled={disabled}
              {...register(field, {
                required,
                pattern,
                onChange: (e) => {
                  if (onChange) {
                    onChange(e);
                  }
                },
              })}
              className="flex-1 pr-2 outline-none text-primary w-1/2 border-primary border-b"
              style={{ height: 36 }}
            />
          </>
        ) : (
          <p className={`text-primary flex-1 ${readOnlyRightAlign ? 'text-right break-words' : 'whitespace-nowrap'}`}>{value}</p>
        )}
      </div>
      {errors?.[field] && errors?.[field]?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
      {errors?.[field] && errors?.[field]?.type === 'pattern' && <span className="text-10 text-red-500">{patternErrorMessage}</span>}
    </>
  );
}

export default EditInput;
